<template>
    <div class="label-node-container" :data-active="isActive" :data-exec-mode="execMode">

        <!-- Modo visualização -->
        <template v-if="execMode == gConsts.rt.execModes.VIEW">
            <div class="label-node-content" @click="toggleActive">
                <labelNodeReportTextCMP :reportNode="reportNode" :execMode="execMode"
                    :reportText="reportNode?.reportText || node.report.text" 
                    @onUpdateInputText="updateLabelReportText"></labelNodeReportTextCMP>
            </div>
        </template>

        <!-- Modo de edição (WORK) -->
        <template v-if="execMode == gConsts.rt.execModes.WORK">

            <!-- Simple view when no report line -->
            <labelNodeHeader v-show="!hasReportLine" :node="node" @click.native="toggleActive" />

            <!-- Expansion panel view -->
            <expansionPanelUI v-show="hasReportLine" @onExpandedChange="toggleActive" :expanded="isActive" class="label-node-expansion-panel">
                <template #header>
                    <labelNodeHeader :node="node" :annotations="isActive ? [] :( reportNode?.annotation.list || [])" />
                </template>
                <template #content>
                    <labelNodeReportTextCMP :reportNode="reportNode" :execMode="execMode"
                        :reportText="reportNode?.reportText || node.report.text" 
                        @onUpdateInputText="updateLabelReportText"></labelNodeReportTextCMP>
                </template>
            </expansionPanelUI>
        </template>
    </div>

</template>

<script>
import { mapGetters } from 'vuex';
import expansionPanelUI from '@/components/ui/expansionPanel.vue';
import labelNodeReportTextCMP from './labelNode/labelNodeReportText.vue';
import labelNodeHeader from './labelNode/labelNodeHeader.vue';

import { gConsts } from '@/globals/gConsts';
import { evtBus } from '@/main';

import ReportNode from '@/features/report/models/ReportNode';

export default {
    name: 'labelNodeCMP',
    components: {
        expansionPanelUI,
        labelNodeReportTextCMP,
        labelNodeHeader
    },
    props: {
        execMode: {
            type: String,
            default: gConsts.rt.execModes.WORK
        },
        node: {
            type: Object,
            required: true
        },
        reportNode: {
            type: ReportNode,
            default: null
        },
        id: {
            type: String,
            required: true
        },
        active: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            gConsts: gConsts,
            isActive: this.active,
        }
    },

    watch: {
        active(newVal) {
            this.isActive = newVal;
        }
    },

    methods: {
        toggleActive() {
            this.isActive = !this.isActive;
            evtBus.$emit('evt_relatorioDinamico_activateNode', { nodeId: this.node.id, nodeType: gConsts.node.layout.types.LABEL });
        },

        updateLabelReportText(reportText) {

            this.$store.dispatch('ACT_reportNodes_updateLabelReportText', {
                labelId: this.node.id,
                text: reportText
            });
        }
    },
    computed: {
        ...mapGetters([
        ]),

        hasReportLine() {
            return ![gConsts.node.report.types.NONE,gConsts.node.report.types.SELECT_ITEM].includes(this.node.report.type);
        }
    }
}
</script>

<style scoped>

/* Modo visualização */

.label-node-container[data-exec-mode="view"] .label-node-content {
    cursor: pointer;
    transition: opacity 0.2s ease;
}

.label-node-container[data-exec-mode="view"] .label-node-content:hover {
    opacity: 0.7;
}

.label-node-container[data-active="true"][data-exec-mode="view"] .label-node-content :deep(.label-node-report-text) {
    font-weight: 600;
}

.label-node-container[data-active="true"][data-exec-mode="view"] .label-node-content :deep(.label-node-report-text-line) {
    text-decoration: underline;
}

/* Modo de edição (WORK) */

.label-node-expansion-panel :deep(.expansion-panel-header) {
    padding: 0 4px;
    border: none !important;
    background: transparent !important;
}

:deep(.label-node-report-text) {
    width: 100%;
}

.label-node-container .label-node-header:hover {
    opacity: 0.7;
    cursor: pointer;
}


.label-node-container[data-active="true"] > :deep(.label-node-header .label-node-header-color) {
    opacity: 0.5;
}

.label-node-container[data-active="true"] > :deep(.label-node-header .label-node-header-title) {
    font-weight: 700;
}

.label-node-container[data-active="true"] .label-node-expansion-panel .label-node-header {
    opacity: 0.5 !important;
}

.label-node-expansion-panel :deep(.expansion-panel-content) {
    padding: 5px 8px;
    border: none !important;
}

</style>